import type { ApiConfig } from '../declare'

const apis: ApiConfig[] = [
  {
    name: 'getEditPageConfigInfo',
    method: 'POST',
    path: '/OP/PageEdit/GetEditPageConfigInfo',
    params: {},
    axiosOptions: {
      noPickParams: true
    },
    desc: '获取编辑表单配置信息'
  }
]

export default apis